import { chatApiInstance as chatApi } from "../apis/chatApi";
import {
  buildToolAuditLogPopup,
  type ToolAuditLogRow,
} from "./shared/buildToolAuditLogPopup";

const ToolAuditLogPopup = buildToolAuditLogPopup(chatApi);

export type { ToolAuditLogRow };
export default ToolAuditLogPopup;
